import { render, staticRenderFns } from "./VoucherBatchForm.vue?vue&type=template&id=5a5928e1&scoped=true"
import script from "./VoucherBatchForm.vue?vue&type=script&lang=js"
export * from "./VoucherBatchForm.vue?vue&type=script&lang=js"
import style0 from "./VoucherBatchForm.vue?vue&type=style&index=0&id=5a5928e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5928e1",
  null
  
)

export default component.exports